export const STATE_NAME = "companyInfo";
export const FORM_NAME = STATE_NAME;
export const SUBMISSION_FORM_NAME = "companyInfoSubmission";
